import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './order-success.css'

const OrderSuccess = () => {
  const { t } = useTranslation('common')
  const location = useLocation()
  const [sessionId, setSessionId] = useState(null)

  useEffect(() => {
    // Get session_id from URL parameters
    const params = new URLSearchParams(location.search)
    const session = params.get('session_id')
    if (session) {
      setSessionId(session)
    }
  }, [location])

  return (
    <div className="order-success-container">
      <Helmet>
        <title>Order Confirmed - ORRAM Frames</title>
        <meta property="og:title" content="Order Confirmed - ORRAM Frames" />
      </Helmet>
      <Navigation />

      <main className="order-success-main">
        <div className="order-success-content">
          <div className="order-success-icon">
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>

          <h1 className="order-success-title">
            Thank You for Your Order!
          </h1>

          <p className="order-success-message">
            Your custom frame order has been successfully placed.
            We'll send you a confirmation email with all the details shortly.
          </p>

          {sessionId && (
            <p className="order-success-reference">
              Order Reference: <code>{sessionId.slice(-8).toUpperCase()}</code>
            </p>
          )}

          <div className="order-success-info">
            <h3>What happens next?</h3>
            <ul>
              <li>You'll receive a confirmation email within a few minutes</li>
              <li>Our craftsmen will begin preparing your custom frame</li>
              <li>We'll notify you when your order ships</li>
            </ul>
          </div>

          <div className="order-success-actions">
            <Link to="/" className="btn btn-primary">
              Return to Homepage
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default OrderSuccess
